import React, { Component }     from 'react';
import { connect }              from 'react-redux';
import {Redirect}               from 'react-router';
import { SetError }             from '../../../actions/notificacaoAction';
import { GetRegistroPostEquipe,
         GetGruposAlunos }      from '../../../actions/grupoAction';
import FlashCarregando          from '../../../container/FlashCarregando';
import EquipeAlunoPostForm      from './equipe_aluno_post_form'; 
import EquipeAlunoPostItem      from './equipe_aluno_post_item';
import EquipeAlunoListar        from './equipe_aluno_lista';
import { GetListaMenuTopo,
    GetListaSubMenuTopo }             from '../../../actions/scopoAction';

import '../../../css/aluno/style_timeline.css';

class Equipe_Aluno extends Component {

    constructor(props) {

        super(props);
        this.state = {
            returnItemPublic : [],
            logPost          : false,
            logAluno         : false,
            logForm          : false,
            logItem          : false,
            redirect         : false,
            id               : (this.props.match ? this.props.match.params.id: "")
        }
    }

    componentDidMount(){

        if (this.props.equipe) {

            const codTurma = this.props.equipe.equ_cod_turma;
            const codDisciplina = this.props.equipe.equ_cod_disciplina;
            this.props.GetListaMenuTopo([
                {
                action : true,
                nome   : "Home",
                link   : this.props.menu.home
                },
                {
                    action : true,
                    nome   : "Equipes",
                    link   : `${this.props.menu.equipe.professor.equipe_turma}/${codTurma}/${codDisciplina}`
                },
                {
                action : false,
                nome   : 'Timeline Equipe'
                }
            ]);

            this.props.GetListaSubMenuTopo([]);
            
        }
        this.CarregarPosts();
    }

    CarregarPosts(){
        this.setState({ logPost : false});
        this.props.GetRegistroPostEquipe(this.props.session.id,this.state.id).then((response) => {
            this.setState({ logPost : true,logForm:true,logAluno:true,equ_id : (response.payload.data.equipe?response.payload.data.equipe.equ_id:0)  });  
            if(!response.payload.data || response.payload.data.equipe=== null){
                alert("O seu usuário, não foi encontrado em nenhum Equipe. Entre em contato com o seu professor, para maiores informações.");
                this.setState({ redirect : true }); 
            }
        }).catch((error) => {
           this.props.SetError(500);
        }); 
    
    }

    render() {
      
        if (this.state.redirect) {
          return (<Redirect to={this.props.menu.equipe.professor.home}/>);
        }

        return (
             <div className="timeline_equipe">
                <div className="row">
                    <div className="col-md-8">
                        <ul className="timeline">
                            <li className="timeline-inverted">

                            {this.state.logPost? <ol className="breadcrumb">
                                <li className="active"><b>{this.props.curso.cur_nome}</b></li>
                                <li className="active"><b>{this.props.turma.tur_nome}</b></li>
                                <li className="active"><b>{this.props.disciplina.dis_nome}</b></li>
                                <li className="active"><b>{this.props.equipe.equ_nome}</b></li>
                            </ol>:""}
                             { 
                                !this.state.logForm ? <FlashCarregando/> : <EquipeAlunoPostForm equ_id={this.state.equ_id}/>
                             }  
                            </li>

                            <li className="timeline-inverted">
                                <button className='btn btn-primary btn-xs btn-block' onClick={this.CarregarPosts.bind(this)}>Clique aqui para cerregar</button>
                            </li>
                        </ul>
                        { 
                           !this.state.logPost ? <FlashCarregando/> : <EquipeAlunoPostItem/> 
                        }
                    </div>
                    <div className="col-md-4">
                        { 
                          !this.state.logAluno ? <FlashCarregando/> : <EquipeAlunoListar equ_id={this.state.equ_id}/> 
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            menu    : state.configReducer.menu,
            turma    : state.equipeReducer.turma,
            curso    : state.equipeReducer.curso,
            disciplina    : state.equipeReducer.disciplina_equipe,
            equipe  : state.equipeReducer.nome_equipe
           }
}

export default connect(mapStateToProps, { GetRegistroPostEquipe, GetGruposAlunos, SetError,GetListaMenuTopo,
    GetListaSubMenuTopo })(Equipe_Aluno);



// WEBPACK FOOTER //
// ./src/components/professor/timeline_equipe/timeline_equipe.js